/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import Draggable from 'react-draggable';
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import utils from "../../utils/utils";
import "./style.less";
class PipelineImgAnimate extends React.Component {
  constructor(props) {
    let clientWidth = 375;
    if (typeof window !== 'undefined') {
      clientWidth = window.document.body.clientWidth;
    }
    const screenRatio = (clientWidth) / 375;
  
    super(props);
    this.state = {
      listHrefConfig: {},
      dragMode: false, // 当前模式，包括编辑和展示两种模式
      isIframe: utils.getParams('isIframe') == 1,
      inSwitchTabIndex: props.tabIndex || 0
    };
    this.screenRatio = screenRatio;
    this.isIphoneX = utils.isIphoneX();
    this.dragEditorRef = null;

    // preloadImages(props);
  }

  componentDidMount() {
    if (typeof window !== 'undefined' && window.self !== window.top) {
      window.addEventListener('message', this.receivePostMessageFromEditor);
    }

    const { itemList = [] } = this.props.config;
    import('svgaplayerweb').then((SVGA) => {
      itemList.forEach((item, index) => {
        const svgaContainer = this.dragEditorRef && this.dragEditorRef.querySelector(`.svgaCanvas-${index + 1}`);
        if (svgaContainer) {
          const player = new SVGA.Player(svgaContainer);
          const parser = new SVGA.Parser(svgaContainer);
          parser.load(item.src, (videoItem) => {
            player.setVideoItem(videoItem);
            player.startAnimation();
          });
        }
      });
    });
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined' && window.self !== window.top) {
      window.removeEventListener('message', this.receivePostMessageFromEditor);
    }
  }

  receivePostMessageFromEditor = (event) => {
    const data = event.data || {};
    const msgType = data.msgType;
    if (msgType === 'checkToBaseConfig') {
      this.setState({
        dragMode: false,
      })
    }
    if (msgType === 'componentSelect') {
      const currentComponent = data.currentComponent;
      if (!currentComponent) {
        return;
      }
      // 编辑器切换组件之后，根据postMessage返回id，确认是否当前组件来切换模式
      if (currentComponent.id && this.props.customAttributes["data-component-block"].indexOf(currentComponent.id) > -1) {
        this.setState({
          dragMode: true,
        })
      } else {
        this.setState({
          dragMode: false,
        })
      }
    }
  }

  handleDragEnd = (index, event, position) => {
    // 拖拽结束，将位置信息发送到编辑器
    const data = {
      left: String(position.x),
      top: String(position.y),
    };
    this.updateDragItemMessage(data, index);
  }

  handleItemResize = (index, event) => {
    const itemEl = event.currentTarget;
    const data = {
      width: String(itemEl.clientWidth),
      height: String(itemEl.clientHeight),
    };
    this.updateDragItemMessage(data, index);
  }

  updateDragItemMessage = (data, index) => {
    if (typeof window !== 'undefined' && window.parent) {
      try {
        window.parent.postMessage({
          componentId: this.props.customAttributes["data-component-id"],
          msgType: 'updateDrag',
          index,
          data,
        }, '*');
      } catch(err) {
        console.log(err);
      }
    }
  }

  transformPx = (num) => {
    // 对单位进行转换
    num = Number(num);
    if (isNaN(num)) {
      num = 0;
    }
    const realNum = Math.round(num * this.screenRatio);
    return realNum;
  }

  render() {
    const { isIframe, inSwitchTabIndex } = this.state
    const { baseConfig, itemList, componentSize = {} } = this.props.config;
    const { width, height } = utils.getAdaptImageSize(componentSize);

    return (
      <div
        ref={ele => {
          if (ele) {
            this.props.exp && this.props.exp(ele);
          }
        }}
        data-dot={JSON.stringify(utils.getExposureData(this.props))}
        className="pipeline-imgAnimate"
        id={this.props['customAttributes']['data-component-id']}
        {...this.props['customAttributes']}
      >
        <div className="hot-map-editor">
          <LazyLoadImage
            className="bg-img"
            width="100%"
            style={{
              width,
              height
            }}
            visibleByDefault={isIframe}
            src={utils.formatImgUrl(baseConfig.backgroundImage, this.props.webpSupport)}
          />
          <div className="drag-editor-container" ref={ref => this.dragEditorRef = ref}>
            {itemList.map((item, index) => {
              const imgSuffix = item.src && item.src.split('.').pop().toLowerCase();
              const width = this.transformPx(item.width);
              const height = this.transformPx(item.height);
              const left = this.transformPx(item.left);
              const top = this.transformPx(item.top);

              return (
                <div key={`item_${index}`} style={{width: '100%', height: '100%'}}>
                  <Draggable
                    disabled={!this.state.dragMode}
                    defaultPosition={{ x: Number(left), y: Number(top) }}
                    bounds="parent"
                    handle=".handle"
                    onStop={this.handleDragEnd.bind(this, index)}
                  >
                    {this.state.dragMode ?
                      (
                        <div
                          className="edit-drag-item"
                          style={{
                            width: `${width}px`,
                            height: `${height}px`,
                            zIndex: index + 100,
                            borderColor: baseConfig.dragFrameColor
                          }}
                          onClick={this.handleItemResize.bind(this, index)}
                        >
                          <div className="handle"></div>
                          {
                            imgSuffix === 'svga'
                              ? <div className={`svgaCanvas-${index + 1}`} style={{width: `${width}px`, height: `${height}px`}}></div>
                              : <img className="item-img"src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" />
                          }
                        </div>
                      ) :
                      (
                        <div
                          className="preview-drag-item hide-border"
                          style={{
                            width: `${width}px`,
                            height: `${height}px`,
                            zIndex: index + 100,
                          }}
                        >
                          {
                            item.src && (
                              imgSuffix === 'svga'
                                ? <div className={`svgaCanvas-${index + 1}`} style={{width: `${width}px`, height: `${height}px`}}></div>
                                : <img className="item-img" src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" />
                            )
                          }
                        </div>
                      )
                    }
                  </Draggable>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

PipelineImgAnimate.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImgAnimate };
export default PipelineImgAnimate;



// WEBPACK FOOTER //
// ./components/pipeline-imgAnimate/index.js